$( document ).ready(function() {
  
  /*home marquee*/
  for(var i = 1; i < 5; i++) {
    $(".marquee_content img").clone().prependTo( ".marquee_content" );
  }

  
});


function updateCart() {
      //free shipping bar
      let fsb_price = $(".free_shipping_bar").attr('ref');
      fsb_price = +fsb_price;
      let total_price = $(".totals__total-value").html().trim().replace('$', '');
      total_price = total_price.replace(' USD', '');
      total_price = +total_price;
      let rem_amount  = fsb_price - total_price;
      let fsb_text = 'YOUR ORDER HAS FREE SHIPPING!';
      if(rem_amount>0) {
        fsb_text = 'you are $'+rem_amount.toFixed(2)+' from free shipping!';
      }
      
      let fsb_progress = (total_price/fsb_price)*100;
      let fsb_content = '<div class="progress-text">'+fsb_text+'</div><div class="progress"><div class="progress-bar" role="progressbar" style="width: '+fsb_progress+'%" aria-valuenow="'+fsb_progress+'" aria-valuemin="0" aria-valuemax="100"></div></div>';
      $(".free_shipping_bar").html(fsb_content);
}

updateCart();